export enum ComplaintPublishStatus {
  PUBLISHED = "PUBLISHED", // เปิดเผย
  UNPUBLISHED = "UNPUBLISHED", // ไม่เปิดเผย
}

export const ComplaintPublishStatusData: { label: string; value: string }[] = [
  {
    label: "COMPLAINTS_PUBLIC",
    value: ComplaintPublishStatus.PUBLISHED,
  },
  {
    label: "COMPLAINTS_PRIVATE",
    value: ComplaintPublishStatus.UNPUBLISHED,
  },
];

export enum COMPLAINTS_FILE_TYPE {
  ATTACH_FILE = 'ATTACH_FILE', //ไฟล์แนบ
  SUMMARY_FILE = 'SUMMARY_FILE', //ไฟล์สรุปผล
}

export enum COMPLAINTS_APPROVE_TYPE {
  APPROVE = 'APPROVE', //อนุมัติ
  NOT_APPROVE = 'NOT_APPROVE', //ไม่อนุมัติ
}

export enum COMPLAINTS_STATUS {
  DRAFT = 'DRAFT', //บันทึกร่าง
  CANCEL = 'CANCEL', //ยกเลิก
  SUBMIT_COMPLAINT = 'SUBMIT_COMPLAINT', //ส่งเรื่องร้องเรียน
  RECEIVE_COMPLAINTS = 'RECEIVE_COMPLAINTS', //รับเรื่องร้องเรียน
  NOT_RECEIVE_COMPLAINTS = 'NOT_RECEIVE_COMPLAINTS', //ปฎิเสธเรื่องร้องเรียน
  APPOINT_MEETING = 'APPOINT_MEETING', //นัดหมายการประชุม
  WAIT_APPROVE = 'WAIT_APPROVE', //รออนุมัติ
  APPROVE = 'APPROVE', //อนุมัติ
  SEND_FOR_REVIEW = 'SEND_FOR_REVIEW', //ส่งทบทวน
}

export const COMPLAINTS_STATUS_DATA: { label: string, value: string }[] = [
  {
    label: "COMPLAINTS_SAVE_DRAFT", //บันทึกร่าง
    value: COMPLAINTS_STATUS.DRAFT
  },
  {
    label: "COMPLAINTS_CANCEL", //ยกเลิก
    value: COMPLAINTS_STATUS.CANCEL
  },
  {
    label: "COMPLAINTS_PENDING",//รอรับเรื่องร้องเรียน
    value: COMPLAINTS_STATUS.SUBMIT_COMPLAINT
  },
  {
    label: "COMPLAINTS_RECEIVED",//รับเรื่องร้องเรียน
    value: COMPLAINTS_STATUS.RECEIVE_COMPLAINTS
  },
  {
    label: "COMPLAINTS_REJECTED",//ปฎิเสธเรื่องร้องเรียน
    value: COMPLAINTS_STATUS.NOT_RECEIVE_COMPLAINTS
  },
  {
    label: "COMPLAINTS_MEETING_SCHEDULED",//นัดหมายการประชุม
    value: COMPLAINTS_STATUS.APPOINT_MEETING
  },
  {
    label: "COMPLAINTS_WAITING_APPROVAL",//รออนุมัติ
    value: COMPLAINTS_STATUS.WAIT_APPROVE
  },
  {
    label: "COMPLAINTS_APPROVE",//อนุมัติ
    value: COMPLAINTS_STATUS.APPROVE
  },
  {
    label: "COMPLAINTS_REVIEW_SUMMARY",//ทบทวนสรุปผล
    value: COMPLAINTS_STATUS.SEND_FOR_REVIEW
  },
]

export const status_edit_list: string[] = [
  COMPLAINTS_STATUS.SUBMIT_COMPLAINT,
  COMPLAINTS_STATUS.RECEIVE_COMPLAINTS,
  COMPLAINTS_STATUS.WAIT_APPROVE,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPOINT_MEETING

]
export const status_not_receive_check: string[] = [
  COMPLAINTS_STATUS.NOT_RECEIVE_COMPLAINTS,
  COMPLAINTS_STATUS.WAIT_APPROVE,
  COMPLAINTS_STATUS.APPROVE,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPOINT_MEETING,
  COMPLAINTS_STATUS.RECEIVE_COMPLAINTS
]
export const status_image_infer: string[] = [
  COMPLAINTS_STATUS.WAIT_APPROVE,
  COMPLAINTS_STATUS.APPROVE,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPOINT_MEETING,
]
export const status_receive_check: string[] = [
  COMPLAINTS_STATUS.RECEIVE_COMPLAINTS,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPOINT_MEETING,
]
export const status_log_check: string[] = [
  COMPLAINTS_STATUS.RECEIVE_COMPLAINTS,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPOINT_MEETING,
  COMPLAINTS_STATUS.APPROVE,
]

export const status_meeting_check: string[] = [
  COMPLAINTS_STATUS.APPOINT_MEETING,
  COMPLAINTS_STATUS.RECEIVE_COMPLAINTS,
  COMPLAINTS_STATUS.WAIT_APPROVE,
  COMPLAINTS_STATUS.SEND_FOR_REVIEW,
  COMPLAINTS_STATUS.APPROVE
]